(() => {
const formSelector='[data-testid="klaviyo-form-RJgUFJ"]';
const seen=new WeakSet();
function inspect(){
 document.querySelectorAll(formSelector).forEach(form=>{
  const modal=form.closest('[role="dialog"]');if(!modal||seen.has(modal))return;seen.add(modal);
  const dismiss=()=>{if(modal.style.display!=='none'&&modal.style.display!==''){modal.querySelector('button[aria-label="Close dialog"]')?.click()}};
  const observer=new MutationObserver(dismiss);observer.observe(modal,{attributes:true,attributeFilter:['style']});dismiss();
 });
}
const additions=new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length))inspect()});
additions.observe(document.body,{childList:true,subtree:true});inspect();
})();